export enum LocationType {
    Warehouse = 'warehouse',
    Store = 'store',
    Dropship = 'dropship',
    Virtual = 'virtual',
}